(ns
  frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.financial-performance
  (:require
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.style.theme.core :as theme]
   [frontend.utils :as fu]))

(defn ^{:jsdoc ["@nocollapse"]} point-formatter
  []
  (this-as
   js-data-point
    (let [point (js->clj js-data-point
                         :keywordize-keys
                         true)
          fm (fu/format "%.1f" (fu/round (/ (:y point) 1000000) 1))]
      fm
      )))

(defn- noi
  [{:keys [labels noi total-income maintenance-expenses]}]
  {:plotOptions {:series {:dataLabels {:enabled   true
                                       :style     {:color       "contrast"
                                                   :textOutline false}
                                       :formatter point-formatter}}
                 :line   {:marker {:enabled false}}}
   :labels      labels
   :colors      (or (util/custom-colors)
                    (util/gradient-colors [:lp-report :chart :bar :gradient-start]
                                          [:lp-report :chart :bar :gradient-end]
                                          3))
   :legend      {:enabled true}
   :tooltip     {:outside         true
                 :useHtml         true
                 :backgroundColor (theme/color [:page-bg :bg])
                 :style           {:opacity         1
                                   :backgroundColor (theme/color [:page-bg :bg])}
                 :shared          true}
   :yAxis       [{:title         false
                  :labels        {:formatter chart-utils/axis-meur-formatter}
                  :softMin       0
                  :softMax       0
                  :lineColor     (theme/color [:chart :y-axis :line])
                  :gridLineColor (theme/color [:chart :y-axis :grid-line])}]
   :xAxis       [{:categories    labels
                  :lineColor     (theme/color [:chart :x-axis :line])
                  :gridLineColor (theme/color [:chart :x-axis :grid-line])}]
   :series      [{:name    "Total income"
                  :type    :column
                  :data    total-income
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  chart-utils/meur-formatter-divide-m}}
                 {:name    "Maintenance expenses"
                  :type    :column
                  :data    maintenance-expenses
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  chart-utils/meur-formatter-divide-m}}
                 {:name    "NOI"
                  :type    :column
                  :data    noi
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  chart-utils/meur-formatter-divide-m}}]})

(defn financial-performance
  [{:keys [report-data] :as props}]
  {:financial-performance-text (report-ctl/rich-content props :financial-performance-text)
   :noi                        (report-ctl/with-footnote
                                props
                                :noi-footnotes
                                (noi (:chart-data-noi report-data)))})
